<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="管理员名称：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入管理员名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="editBtn('')" size="small" type="primary" class="bg-theme">添加管理员</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="管理员名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="登录账户">
          </el-table-column>
          <el-table-column
            align="center"
            prop="roleName"
            label="角色">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
              <el-button @click="pwdOpenBtn(scope.row.id)" type="text" size="small">修改密码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="pwdShow"
      width="960px">
      <el-form :model="pwdForm" label-width="140px">
        <el-form-item label="旧密码：" prop="oldUserPassword">
          <el-input v-model="pwdForm.oldUserPassword" type="password" show-password placeholder="请输入旧密码" style="width: 424px;"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="userPassword">
          <el-input v-model="pwdForm.userPassword" type="password" show-password placeholder="请输入新密码" style="width: 424px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="pwdSaveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryManagementUserPageList, removeManagementUserById, updatePassword } from '@/api/setting'
export default {
  name: 'Manager',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoId:'',
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 修改密码弹窗
      pwdShow:false,
      pwdForm:{
        oldUserPassword:'',
        userPassword:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryManagementUserPageList({ nickName: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 修改密码弹窗-打开操作
    pwdOpenBtn (infoId) {
      this.infoId = infoId;
      this.pwdForm = {
        oldUserPassword:'',
        userPassword:''
      }
      this.pwdShow = true;
    },
    // 修改密码弹窗-保存操作
    pwdSaveBtn (infoId) {
      var infoId = this.infoId;
      var pwdForm = this.pwdForm;
      var that = this;
      that.fullscreenLoading = true
      updatePassword({ id: infoId, userPassword: pwdForm.userPassword, oldUserPassword: pwdForm.oldUserPassword }).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.pwdShow = false;
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/manager_add', query: {dataId: infoId}})
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeManagementUserById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/Manager.vue